/* globals msgifs */

import Gifa11y from './gifa11y-src';

(function (window, document) {
	const setupGifa11y = function () {
		const gifa11y = new Gifa11y({ // eslint-disable-line
			container: 'main',
			buttonBackground: '#0067b8',
			buttonBackgroundHover: '#243a5e',
			buttonFocusColor: 'rgba(255,255,255,.5)',
			buttonIconColor: 'white',
			initiallyPaused: true,
			langPause: msgifs.pause,
			langPlay: msgifs.play,
			missingAltWarning: false,
		});
	};

	if (document.readyState !== 'loading') {
		document.addEventListener('DOMContentLoaded', setupGifa11y());
	} else {
		setupGifa11y();
	}
})(window, document);
